<template>
  <!--
    Declaration sample :
    <score-bloc
      text_align="right"
      indicator_color="black"
      indicator_text="97.5 %"
      desc_color="grey"
      desc_text="Disponibility"
      icon_type="up"
    />

    <script>
      import ScoreBloc from "../components/UI_kit/ScoreBloc.vue"

      export default {
        components: {
          ScoreBloc,
        },
      }

    </script>
  -->

  <v-container class="d-flex flex-row justify-space-between px-0" fluid>
    <div :class="'d-flex flex-column align-' + text_align">
      <h1 class="pb-2" :style="'color: ' + indicator_color">{{ indicator_text }}</h1>
      <div class="'pa-0 text-body-2 align-left" :style="'color: ' + desc_color">{{ desc_text }}</div>
    </div>
    <div class="pl-2 pr-0 py-0 ma-0 align-right">
      <v-icon size="52" :color="getIconColor">{{ getIconFont }}</v-icon>
    </div>
  </v-container>
</template>


<script>
    export default {
      name: "score_bloc",

      props: {
        event_name: {
          type: String,
          required: true,
        },

        text_align: {
          type: String,
          required: true,
          default: 'left'
        },

        indicator_color: {
          type: String,
          required: true,
          default: 'black'
        },

        indicator_text: {
          type: String,
          required: true,
        },

        desc_color: {
          type: String,
          required: true,
          default: 'grey'
        },

        desc_text: {
          type: String,
          required: true,
        },

        icon_type: {
          type: String,
          required: true,
          default: 'middle',
        },
      },

      data() {
        return {}
      },

      watch: {},

      computed: {
        getIconFont() {
          if (this.icon_type === 'up') {
            return 'mdi-arrow-up-thin-circle-outline'
          } else if (this.icon_type === 'down') {
            return 'mdi-arrow-down-thin-circle-outline'
          } else {
            return 'mdi-arrow-right-thin-circle-outline'
          }
        },

        getIconColor() {
          if (this.icon_type === 'up') {
            return 'green'
          } else if (this.icon_type === 'down') {
            return 'red'
          } else {
            return 'grey'
          }
        }
      },

      methods: {},

    }
</script>

<style scoped />
